// frontend/src/native/pushOpened.ts
//
// X-03: Push-Oeffnungen messen. Jede serverseitige Push traegt in ihren Daten
// eine Kennung `plid` (server/push/send.js). Tippt der Nutzer die Push an,
// meldet der Klick-Listener sie an POST /api/push/opened — der Server setzt
// push_log.opened_at. Fire-and-forget: kein Warten, keine Fehlermeldung, nie
// ein Einfluss auf die Navigation.

import { apiRequest } from '../api/client';

const PLID_PATTERN = /^[a-f0-9]{8,64}$/;
/** Pro App-Sitzung jede Kennung hoechstens einmal melden (Klick + Kaltstart). */
const reported = new Set<string>();

export function readPushLogId(additionalData: Record<string, unknown> | null | undefined): string | null {
  const raw = additionalData?.plid;
  if (typeof raw !== 'string') return null;
  const plid = raw.trim().toLowerCase();
  return PLID_PATTERN.test(plid) ? plid : null;
}

export function reportPushOpened(additionalData: Record<string, unknown> | null | undefined): void {
  const plid = readPushLogId(additionalData);
  if (!plid || reported.has(plid)) return;
  reported.add(plid);
  try {
    void apiRequest('/api/push/opened', { method: 'POST', body: { plid } }).catch(() => undefined);
  } catch {
    // Messung darf den Push-Klick nie stoeren.
  }
}

/** Nur fuer Tests. */
export function resetReportedPushOpensForTests(): void {
  reported.clear();
}
